<template>
    <div component="PriceInputs">
        <div>
            <span>TV</span>
            <input v-model="prices.tv" :style="style(1)" />
        </div>

        <div>
            <span>Radio</span>
            <input v-model="prices.radio" :style="style(2)" />
        </div>

        <div>
            <span>Dubbing</span>
            <input v-model="prices.dubbing" :style="style(3)" />
        </div>

        <div>
            <span>Online</span>
            <input v-model="prices.online" :style="style(4)" />
        </div>

        <div>
            <span>Other</span>
            <input v-model="prices.other" :style="style(5)" />
        </div>

        <btn text="SAVE" @click="save"></btn>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
    name: 'PriceInputs',

    props: {
        winner: {
            type: Object,
            required: true,
        },
        typ: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },

    mounted() {
        this.winner.prices.forEach((value) => {
            switch (value.id_typ_diela) {
                case 1:
                    this.prices.tv = value.cena;
                    break;
                case 2:
                    this.prices.radio = value.cena;
                    break;
                case 3:
                    this.prices.dubbing = value.cena;
                    break;
                case 4:
                    this.prices.online = value.cena;
                    break;
                case 5:
                    this.prices.other = value.cena;
                    break;
            }
        });
    },

    data: () => ({
        prices: {
            tv: 0,
            radio: 0,
            dubbing: 0,
            online: 0,
            other: 0,
        },
    }),

    methods: {
        ...mapActions(['storePrice', 'loadOrderProject']),

        style(type) {
            let style = {
                border: '1px solid ' + this.color,
            };

            if (this.typ === type) {
                style['background-color'] = this.color;
            }

            return style;
        },

        async save() {
            await this.storePrice({
                id: this.winner.id,
                prices: this.prices,
                projectId: this.$route.params.project_id,
            });

            this.loadOrderProject(this.$route.params.project_id);
        },
    },

    computed: {},
};
</script>

<style lang="less">
@import '~@variables';

[component='PriceInputs'] {
    justify-content: space-between;
    padding: 5px 5px 5px 15px;
    align-items: flex-end;
    display: flex;

    div {
        flex: 1;
    }

    input {
        padding: 3px 6px;
        width: 80px;
    }
}
</style>
